import React, { useContext } from 'react';

import moment from 'moment';

import { GlobalContext } from '../../../../store';
import { IGame } from '../../../../store/player/games/store';

import { CurrentEventTeeTimeParings } from './Components/CurrentEventTeeTimeParings/CurrentEventTeeTimeParings';
import { placeholderImage } from '../../../../assets/images';

interface IProps {
  currentGame: IGame;
}

export const CurrentEvent = ({ currentGame }: IProps): JSX.Element => {
  const { events } = useContext(GlobalContext);

  const eventId = currentGame && currentGame.round.event;
  const eventGame = events && events.all && Object.values(events.all).find(e => eventId === e.id);
  const eventImage = eventGame && eventGame.image ? eventGame.image : null;
  const eventName = eventGame && eventGame.name ? eventGame.name : '';
  const eventClub = eventGame && eventGame.club && eventGame.club.name ? eventGame.club.name : '';

  return (
    <div className={`current-event ${currentGame ? '' : 'hidden'}`}>
      <div className="content-wrapper">
        <div
          className="bg-wrapper"
          style={{
            backgroundImage: `url(${eventImage ? eventImage : placeholderImage})`
          }}
        >
          <div className="bg-mask2" />
        </div>

        <div className="content">
          <h3>{eventClub}</h3>

          <h2>{eventName}</h2>

          <div className="desc">
            <p>{currentGame ? moment(currentGame.group.start).format('MMMM D, YYYY') : ''}</p>
            <p>At {currentGame.round.course.name}</p>
          </div>
        </div>
      </div>

      <CurrentEventTeeTimeParings currentGame={currentGame} />
    </div>
  );
};
